module.exports = __webpack_public_path__ + "media/pages/Home/images/Landing_YoungGirl-2f4bc9d883d10a99b076c244ea322232.jpg";